import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    checkboxCell: {
      padding: '0 0 0 15px !important',

      '& .MuiCheckbox-root': {
        padding: 0,
      },

      '& span > span > svg': { width: 15, height: 15 },
    },
    linkToInstances: {
      textDecoration: 'none',
      color: palette.blue,
    },
    iconCancel: {
      color: palette.red,
      height: 15,
      width: 15,
      padding: '0px 10%',
      '& .MuiIconButton-root': { padding: 0 },
    },
    dateCell: {
      '& .MuiGrid-root': {
        justifyContent: 'center',
      },
    },
    removeAction: {
      color: palette.error.light,
      '&:hover': {
        color: palette.error.main,
      },
      borderColor: palette.black,
      padding: '2px !important',
    },
    removeButton: {
      background: palette.error.main,
      color: palette.error.contrastText,
      marginLeft: 16,
      height: 30,
      padding: '5px 12px',

      '&:hover': {
        background: palette.error.dark,
      },
    },
  });
